import React from 'react'
import { startCase } from 'lodash'
import { Chip, P } from '@allied-solutions/affinity'

const TagPill = ({ tagName, ...rest }) => (
  <Chip
  rounded 
    css={`
      padding-left: ${props => props.theme.space['3']};
      padding-right: ${props => props.theme.space['3']};
      background-color: ${props => props.theme.colors.blue800};
      border: none;
      };
    `}
    justifyContent="center"
    minWidth={'61px'}
    px="3"
    size="sm"
    {...rest}
    label={<P
      mb={0}
      textAlign="center"
      color="white"
      height="100%"
      lineHeight="normal"
    >
      {startCase(tagName)}
    </P>}
  >
  </Chip>
)

export { TagPill }
